import { left, right, map } from 'fp-ts/lib/Either';
import { flow } from 'fp-ts/lib/function';
import { useEffect, useState } from 'react';
import { useNameSyncFlow } from '.';
import { useQuery } from '../common';

// code: '' is for not-name-sync
// code: not empty string is for name-sync
export function useNameSync() {
  let query = useQuery();

  const nameSyncFlow = useNameSyncFlow();

  const [code, setCode] = useState('');

  useEffect(() => {
    const handleSubmit = flow(
      query.get.bind(query),
      code => (code !== null && nameSyncFlow ? right(code as string) : left('')),
      map(setCode)
    );

    handleSubmit('code');
  }, [query, nameSyncFlow]);

  return code;
}
